import { ButtonSimple } from '@jollywise/jollygoodgame/src/input/ButtonSimple';

export class ButtonTT extends ButtonSimple {
  constructor(scene, opts) {
    super(scene, { ...opts, clickSFX: opts.clickSFX || { sprite: 'sfx', id: 'button_press' } });
    this._hitarea = {
      x: -this.width * 0.5,
      y: -this.height * 0.5,
      width: this.width,
      height: this.height,
    };
  }

  enable() {
    super.enable();
  }

  setTexture(...args) {
    super.setTexture(...args);
    if (this.input && this._hitarea)
      this.input.hitArea.setTo(
        this.width * 0.5 + this._hitarea.x,
        this.height * 0.5 + this._hitarea.y,
        this._hitarea.width,
        this._hitarea.height
      );
  }
}
